import { render, staticRenderFns } from "./PurchasePolymerize.vue?vue&type=template&id=4c415bac&scoped=true"
import script from "./PurchasePolymerize.vue?vue&type=script&lang=js"
export * from "./PurchasePolymerize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c415bac",
  null
  
)

export default component.exports